import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import pt from "../locales/pt-BR.json";
import es from "../locales/es-CL.json";
import en from "../locales/en-US.json";
import legacyPt from "../locales/legacy/pt-BR.json";
import legacyEs from "../locales/legacy/es-CL.json";
import legacyEn from "../locales/legacy/en-US.json";
import { storage } from "./config";
export const locales = ["pt-BR", "es-CL", "en-US"];
const selected = storage.get<string>("locale") || navigator.language;
void i18n.use(initReactI18next).init({
  resources: {
    "pt-BR": { translation: { ...legacyPt, ui: pt } },
    "es-CL": { translation: { ...legacyEs, ui: es } },
    "en-US": { translation: { ...legacyEn, ui: en } },
  },
  lng: locales.includes(selected)
    ? selected
    : selected.startsWith("es")
      ? "es-CL"
      : selected.startsWith("en")
        ? "en-US"
        : "pt-BR",
  fallbackLng: "pt-BR",
  interpolation: { escapeValue: false },
});
i18n.on("languageChanged", (lang) => {
  storage.set("locale", lang);
  document.documentElement.lang = lang;
});
export function friendlyError(code: string) {
  const mapped: Record<string, string> = {
    "auth/invalid-verification-code": "invalidOtp",
    "auth/code-expired": "smsExpired",
    "auth/invalid-phone-number": "invalidPhone",
    "auth/too-many-requests": "server",
    "auth/network-request-failed": "network",
    "auth/captcha-check-failed": "captchaFailed",
    "auth/unauthorized-domain": "authDomainNotAllowed",
    "auth/invalid-app-credential": "authAppVerificationFailed",
    "auth/invalid-app-credentials": "authAppVerificationFailed",
    "auth/quota-exceeded": "smsQuotaExceeded",
    "auth/operation-not-allowed": "phoneAuthUnavailable",
    FEEDBACK_ALREADY_GIVEN: "alreadyAnswered",
    FEEDBACK_EXPIRED: "expired",
    "TCK-INVALID-CODE": "invalidCode",
    CHECKIN_TIMEOUT: "timeout",
  };
  const k = mapped[code] || code;
  return i18n.exists(`ui.${k}`)
    ? i18n.t(`ui.${k}`)
    : i18n.exists(`messages.error.${code}`)
      ? i18n.t(`messages.error.${code}`)
      : i18n.t("ui.generic");
}
export default i18n;
